export const generalMail = 'info@fysiohier.com';

export const legalName = 'Fysio Hier B.V.';
export const streetName = 'Loopkantstraat';
export const streetNumber = '20';
export const zipcode = '5405 AC';
export const state = 'Noord-Brabant';
export const city = 'Uden';
export const phoneNumber = '0413 289 694';
export const internationalPhoneNumber = '+31 413 289 694';
export const mapsUrl
	= 'https://maps.apple.com/?address=Loopkantstraat%2020,%205405%20AC%20Uden,%20Netherlands&auid=7536131861451422849&ll=51.657520,5.639300&lsp=9902&q=Fysio%20Hier';
